import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const HeroService = dynamic(() =>
  import('modules/services/HeroService').then(mod => mod.HeroService),
);
const ServiceAbout = dynamic(() =>
  import('modules/services/ServiceAbout').then(mod => mod.ServiceAbout),
);
const CTA = dynamic(() => import('common/components/Cta').then(mod => mod.CTA));
const WorkCaseStudiesCarousel = dynamic(() =>
  import('modules/work/WorkCaseStudiesCarousel').then(mod => mod.WorkCaseStudiesCarousel),
);

const ServicePage = () => {
  const { t } = useTranslation('meta');

  const schemaMarkup = [
    {
      '@type': 'Service',
      name: t('serviceSingle.businessSolutions.title'),
      image: t('serviceSingle.businessSolutions.image'),
      description: t('serviceSingle.businessSolutions.description'),
      brand: {
        '@type': 'Brand',
        name: 'Nordit d.o.o.',
        logo: {
          '@type': 'ImageObject',
          url: 'https://firebasestorage.googleapis.com/v0/b/nordit-83a0b.appspot.com/o/logo%2FNordit%20logo%20-%20primary%20white%2FNordit%20logo%20-%20primary%20white%402x.png?alt=media&token=d979ae78-414f-4fd1-bfb5-dc31ad8ce3cf',
        },
      },
    },
  ];
  const seo = {
    alternate: t('serviceSingle.businessSolutions.alternate', { returnObjects: true }),
    description: t('serviceSingle.businessSolutions.description'),
    image: t('serviceSingle.businessSolutions.image'),
    schemaMarkup,
    slug: t('serviceSingle.businessSolutions.slug'),
    title: t('serviceSingle.businessSolutions.title'),
  };
  return (
    <Layout dark seo={seo}>
      <HeroService translationKey="businessSolutions" />
      <ServiceAbout translationKey="businessSolutions" />
      <CTA dark fullHeight={false} />
      <WorkCaseStudiesCarousel />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IServicePageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'meta',
    'pageServices',
    'projectItemsOverview',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IServicePageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default ServicePage;
